import {
  ADD_NOTIFICATION,
  NotificationActionTypes,
  NotificationMessage,
  REMOVE_TOP_NOTIFICATION,
} from './types';

export function addNotification(notification: NotificationMessage): NotificationActionTypes {
  return {
    type: ADD_NOTIFICATION,
    payload: notification,
  };
}

export function removeTopNotification(): NotificationActionTypes {
  return {
    type: REMOVE_TOP_NOTIFICATION,
  };
}
